// extracted by mini-css-extract-plugin
module.exports = {"measurementInput":"MeasurementInput_measurement-input__1cU_q"};